import React, { useState, useEffect } from 'react'
import PopupModal from '../../../../components/popup-bottom-modal'
import { getRemoveShareUserReasonEnum, removeShareUserRelation } from '../../api'
import TagList from '../tag-list'
import Toast from '@xpeng/rc-toast'
import { trackGdp } from '../../../../utils/gio-report'
import { UserTypeEnum } from '../../../../api/pile'

import './index.less'

interface SharingRemoveModalPropsRule {
    visible: boolean
    setVisible: (status: boolean) => void
    data: any
    refresh: () => void
    userInfo: any
}

const SharingRemoveModal = (props: SharingRemoveModalPropsRule) => {
    const { visible, setVisible, data, userInfo, refresh } = props
    const [removeReasonList, setRemoveReasonList] = useState<any[]>([])
    const [selectedReason, setSelectedReason] = useState<any>({})

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        const { data } = await getRemoveShareUserReasonEnum()
        if (data?.length) {
            setRemoveReasonList(data)
        }
    }
    const close = async () => {
        // 上报埋点
        trackGdp('P20076', 'B003', {
            userId: userInfo?.uid,
            userType: UserTypeEnum[userInfo?.type],
            user_type: UserTypeEnum[userInfo?.type]
        })
        if (!selectedReason?.code) {
            Toast.show('请选择移除原因', {
                containerStyle: { zIndex: 1000 }
            })
            return
        }
        if (data?.id) {
            const removeRes = await removeShareUserRelation({
                id: data?.id,
                removeResonType: selectedReason.code
            })
            if (removeRes?.code === 200) {
                Toast.show(data?.newestOrderStatus === '04' ? '移除成功，当前用户正在充电中，本次充电结束后将无法再使用你的充电桩' : '移除成功')
                setVisible(false)
                refresh()
            } else {
                Toast.show('移除失败', {
                    containerStyle: { zIndex: 1000 }
                })
            }
        } else {
            Toast.show('无站点id', {
                containerStyle: { zIndex: 1000 }
            })
        }

    }
    return (
        visible
            ?
            <PopupModal
                visible={visible}
                title='移除共享确认'
                onClose={() => { setVisible(false) }}
            >
                <div className='close-container'>
                    <div className='tip'>移除共享后该用户将无法继续使用你的充电桩，请谨慎操作</div>
                    <div className='reason-title'>
                        <div className='reason-required-icon'>*</div>
                        <div className='reason-title-text'>选择原因</div>
                    </div>
                    <div className='tag-list-container'>
                        <TagList
                            list={
                                removeReasonList
                            }
                            onChange={(data) => setSelectedReason(data)}
                        />
                    </div>
                    <div className='btn-container'>
                        <div
                            className='confirm-btn'
                            onClick={() => { setVisible(false) }}
                        >
                            再想想
                        </div>
                        <div
                            className='cancel-btn'
                            onClick={close}
                        >
                            确认移除
                        </div>
                    </div>
                </div>
            </PopupModal>
            : null
    )
}

export default SharingRemoveModal